window.app = window.app || {};

(function($) {

	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#step1Info',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/book/review_your_reservation',
			SESSION_EXPIRED: '/book/session_expired',
			PERFORM_CYBERSOURCE_AUTH: function() {

				var options = {
					ajaxURLs: {
						performCyberSourceAuth:                '/h/book/AjaxPerformCyberSourceAuth',
						storeCardinalJwtResponse:              '/h/book/AjaxStoreCardinalJwtResponse',
						cyberSourcePayerAuthValidationRequest: '/h/book/AjaxCyberSourcePayerAuthValidationRequest'
					}
				};

				var formHelperRequest = this;
				formHelperRequest.$form.addClass('cybersource-3ds-active');
				formHelperRequest.disableControls();
				formHelper.portholeSendFHIPeerCustomEvent({"event":"disableControls"});
				var newCybersource3ds = new Cybersource3ds(options);
				newCybersource3ds.performCyberSourceAuth(formHelperRequest, function processStatus(formHelperRequest, status) {

					console.log(status);

					switch (status) {

						case 'VALIDATION_SUCCESS':
							window.location = '/book/review_your_reservation';
							break;

						case 'VALIDATION_FAILURE':
						case 'SERVICE_TIME_OUT':
						case 'DATA_RESPONSE_ERROR':
							var msgLocalizedForJSLabel = 'Cybersource3DS_' + status;
							var p = $('<p>').text(localizedForJS[msgLocalizedForJSLabel].unescapeHTML())[0];
							toggleBlanket('alert',p,'');
							formHelperRequest.$form.removeClass('cybersource-3ds-active');
							formHelperRequest.enableControls();
							formHelper.portholeSendFHIPeerCustomEvent({"event":"enableControls"});
							break;
					}
				});
			}
		}
	});

	formHelper.addRule({
		form: '#step1InfoNoPayment',
		status: {
			SUCCESS: '/book/review_your_reservation'
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});

})(jQuery);


jQuery(function($){

	$(document).on('click','.fh-js-step1Info-submitter',function(event){
		if (window.app.doCheckOutstandingChargeTotal()) {
			if (window.app.promoCodeFieldEmpty()) {
				event.preventDefault();
				$('#step1Info, #step1InfoNoPayment').submit();
			}
		}
	});
});
